module.exports = __webpack_public_path__ + "888615d868be7eb237191cf5f7e18c76.eot";


//////////////////
// WEBPACK FOOTER
// ./app/fonts/kff-cds.eot?e1re96
// module id = 371
// module chunks = 0